import MUIFormControlLabel from '@mui/material/FormControlLabel'

export const FormControlLabel = MUIFormControlLabel
